import React, { useState } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
  CardBody,
  Col,
  Container,
  Card,
  Row,
  Nav,
  NavItem,
  TabContent,
  TabPane,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getOffersWithRegularMatching } from "../../store/offers/actions";
import NotificationsTable from "./components/NotificationsTable";
import WarehouseTable from "./components/WarehouseTable";
import Breadcrumbs from "../../components/Common/Breadcrumb";
// import { queryString } from "query-string";
import { getWHCheckCampaignNames } from "../../store/warehouse/actions";
import ModifiedMetaTags from '../../components/ModifiedMetaTags/index';

const NotificationsPage = props => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("campaigns"); // statistics
  const offers_with_regular_matching = useSelector(
    state => state.Offers.offers_with_regular_matching
  );
  const is_loading_offers_with_regular_matching = useSelector(
    state => state.Offers.is_loading_offers_with_regular_matching
  );
  const campaignNamesData = useSelector(state => state.Warehouse.campaignNamesData);
  const whNamesLoader = useSelector(state => state.Warehouse.whNamesLoader);

  React.useEffect(() => {
    const location = props.history.location;
    const hash = props.location.hash.split("#").join("") || "statistic";
    location.hash = hash;
    props.history.replace(location);
    toggle(hash);
    dispatch(getWHCheckCampaignNames());
    dispatch(getOffersWithRegularMatching());
  }, []);

  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const handleUpdateTab = () => {
    const hash = props.location.hash.split("#").join("") || "statistic";
    toggle(hash);
  };

  const onTableStatisticChange = (data) => {
    dispatch(getOffersWithRegularMatching({
      ordering: data.ordering,
    }));
  }

  const onTableCampaignsChange = (data) => {
    dispatch(getWHCheckCampaignNames({
      ordering: data.ordering,
    }));
  }

  return (
    <React.Fragment>
      <div className="page-content">
      <ModifiedMetaTags title="Health | Mobihunter" />

        <Container fluid>
          <Breadcrumbs
            title="Dashboard"
            breadcrumbItem="Health"
            link="/"
            className="fade-in-custom-animate"
          />
          <Row>
            <Col sm="col-12">
              <Card className="mb-0">
                <CardBody>
                  <Nav
                    tabs
                    className="nav-tabs-custom"
                    style={{
                      width: "80%",
                      borderBottom: "0",
                    }}
                  >
                    <NavItem>
                      <Link
                        style={{ cursor: "pointer" }}
                        to={{
                          hash: "statistic",
                          search: props.location.search,
                        }}
                        className={classnames("nav-link", {
                          active: activeTab === "statistic",
                        })}
                        onClick={() => {
                          toggle("statistic");
                        }}
                      >
                        Statistic
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link
                        style={{ cursor: "pointer" }}
                        to={{
                          hash: "campaigns",
                          search: props.location.search,
                        }}
                        className={classnames("nav-link", {
                          active: activeTab === "campaigns",
                        })}
                        onClick={() => {
                          toggle("campaigns");
                        }}
                      >
                        Campaigns
                      </Link>
                    </NavItem>
                  </Nav>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <TabContent
            activeTab={activeTab}
            className="text-muted"
            style={{ padding: "40px 12px 0px 12px" }}
          >
            <TabPane tabId="statistic">
              <Row>
                <Col className="col-12">
                  <Card>
                    <CardBody>
                      <NotificationsTable
                        data={offers_with_regular_matching || []}
                        isLoading={is_loading_offers_with_regular_matching}
                        onTableChange={onTableStatisticChange}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="campaigns">
              <Row>
                <Col className="col-12">
                  <Card>
                    <CardBody>
                      <WarehouseTable data={campaignNamesData || []} isLoading={whNamesLoader} onTableChange={onTableCampaignsChange} />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  );
};

NotificationsPage.propTypes = {
  data: PropTypes.any,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const NotificationsPageStyled = styled.div``;

export default NotificationsPage;
